import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from './Button';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

interface props {
  onClick: () => void;
  disabled: boolean;
}

const ClearFilterButton = ({ onClick, disabled }: props) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    className={disabled ? '!bg-transparent' : ''}
    endIcon={<FontAwesomeIcon icon={faCircleXmark} />}
    color="transparent"
  >
    Clear Filters
  </Button>
);
export default ClearFilterButton;
